/*
 * Atomz discount - a code field on the cart.
 *
 * Shopify does not take discount codes through the AJAX cart: /cart/update.js
 * has no field for them and never has. The supported route is /discount/<CODE>,
 * which applies the code to the cart session and redirects, and the code then
 * carries into checkout on its own. So this navigates rather than fetches.
 *
 * THE PART THAT IS NOT PRETTY. There is no endpoint that answers "is this code
 * valid", and /discount redirects back silently when it is not, so a shopper
 * would otherwise type a wrong code and watch nothing happen. The redirect
 * carries the code back in the query string, and on the way back this asks
 * /cart.js whether that code is on the cart. If it is not, it says so. That is
 * a check after the fact rather than validation before, which is the most the
 * platform allows from a theme.
 *
 * FAILURE MODE: no script and the form is a GET to /cart, which reloads the
 * cart and does nothing else. It cannot apply a code without this, so the
 * field is hidden until the script is here to drive it.
 */
(function () {
  'use strict';

  var PARAM = 'az_tried';

  function forms() {
    return document.querySelectorAll('[data-az-discount]');
  }

  function say(form, text, bad) {
    var el = form.querySelector('[data-az-discount-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('is-bad', !!bad);
  }

  function apply(form) {
    var input = form.querySelector('[data-az-discount-input]');
    var code = input && input.value.trim();
    if (!code) {
      say(form, 'Enter a code first.', true);
      if (input) input.focus();
      return;
    }

    /* Where to come back to, carrying what was tried so the answer can be
       checked on arrival. */
    var back = new URL(window.location.href);
    back.searchParams.set(PARAM, code);

    window.location.href = '/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(back.pathname + back.search);
  }

  /*
   * Did the code we just sent them to actually land? Shopify puts the cart's
   * codes on /cart.js with an `applicable` flag, so this reads the answer
   * rather than guessing from the total.
   */
  function checkTried() {
    var tried;
    try { tried = new URLSearchParams(window.location.search).get(PARAM); } catch (e) {}
    if (!tried || !window.fetch) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var codes = cart.discount_codes || [];
        var hit = null;
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code).toLowerCase() === tried.toLowerCase()) hit = codes[i];
        }
        var good = hit && hit.applicable !== false;
        Array.prototype.forEach.call(forms(), function (form) {
          if (good) {
            say(form, tried + ' applied.', false);
            var input = form.querySelector('[data-az-discount-input]');
            if (input) input.value = '';
          } else {
            say(form, '“' + tried + '” did not apply to this cart.', true);
          }
        });
      })
      .catch(function () { /* say nothing rather than guess */ });
  }

  function init() {
    var list = forms();
    if (!list.length) return;

    Array.prototype.forEach.call(list, function (form) {
      form.setAttribute('data-az-ready', '');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        apply(form);
      });
    });

    checkTried();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
